import * as React from "react";
const SvgHourglass = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M10.667 26.667h10.666v-4q0-2.2-1.566-3.767T16 17.333 12.233 18.9t-1.566 3.767zm5.333-12q2.2 0 3.767-1.567t1.566-3.767v-4H10.667v4q0 2.2 1.566 3.767T16 14.667M6.667 29.333q-.567 0-.95-.384A1.3 1.3 0 0 1 5.333 28q0-.565.384-.95.386-.383.95-.383H8v-4q0-2.034.95-3.818A7.4 7.4 0 0 1 11.6 16a7.4 7.4 0 0 1-2.65-2.85A8 8 0 0 1 8 9.334v-4H6.667q-.567 0-.95-.384A1.3 1.3 0 0 1 5.333 4q0-.565.384-.95.386-.383.95-.383h18.666q.567 0 .951.384t.383.949q-.002.566-.384.95a1.28 1.28 0 0 1-.95.383H24v4a8 8 0 0 1-.95 3.818A7.4 7.4 0 0 1 20.4 16a7.43 7.43 0 0 1 2.65 2.85q.95 1.785.95 3.817v4h1.333q.567 0 .951.384t.383.949q-.002.566-.384.95a1.28 1.28 0 0 1-.95.383z"
    />
  </svg>
);
export default SvgHourglass;
